/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { API_RUBUSMASTERS } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { UpdateMasters, CreateMasters, deleteMasters } from '../../APICalls';
import { Form, Input, message, Button, Drawer, Tooltip, Popconfirm } from 'antd';
import translation from '../../Utils/translation';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';

const ApiList = {
  CreateDynamic: `${API_RUBUSMASTERS.DynamicHierarchyCREATE}`,
  UpdateDynamic: `${API_RUBUSMASTERS.DynamicHierarchyUPDATE}`,
  DeleteDynamic: `${API_RUBUSMASTERS.DynamicHierarchyDELETE}`
};

const DynamicHierarchy = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleDynamic, setVisibleDynamic] = useState(false);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);


  const hForm = useRef(null);

  useEffect(() => {
    _getList();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [translationCache]);



  const _getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_RUBUSMASTERS.DynamicHierarchy_Get}?SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    let textValue = JSON.stringify(record.Actions);
    let formObject = {
      ...record,
      Actions: textValue,
      Id: record.Id
    };
    hForm.current && hForm.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setVisibleDynamic(true);
  };

  const deleteRecord = async (id) => {
    let deleteResponse = await deleteMasters(ApiList.DeleteDynamic, id);
    message.success(deleteResponse && deleteResponse.message);
    _getList();
  };

  const onFinish = async () => {
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(ApiList.UpdateDynamic, payload, formObject.Id);
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let createResponse = await CreateMasters(ApiList.CreateDynamic, payload);
            message.success(createResponse && createResponse.message);
          }
          _getList();
          hForm.current &&
            hForm.current.setFieldsValue({
              Level: null,
              Name: null,
              ModuleCode: null,
              LevelType: null,
              Type: null,
              Actions: null
            });
          setFormObject({});
          setVisibleDynamic(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const OpenDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Level: null,
        Name: null,
        ModuleCode: null,
        LevelType: null,
        Type: null,
        Actions: null
      });
    let formObject = {
      Level: null,
      Name: null,
      ModuleCode: null,
      LevelType: null,
      Type: null,
      Actions: null
    };
    setFormObject(formObject);
    setVisibleDynamic(true);
  };

  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Level: null,
        Name: null,
        ModuleCode: null,
        LevelType: null,
        Type: null,
        Actions: null
      });
    setFormObject({});
    setVisibleDynamic(false);
  };

  const handleChange = (e, key) => {
    // let formObject = hForm.current && hForm.current.getFieldsValue(); //remove this line
    let newFormObject = { ...formObject };
    if (key === 'Actions') {
      try {
        let data = JSON.parse(e.target.value);
        newFormObject = {
          ...newFormObject,
          Actions: data
        };
        setFormObject(newFormObject);
      } catch (error) {
        // message.error('Invalid JSON format for Actions');
        return;
      }
    }
  };

  const columns = [
    {
      title: 'Module Code',
      dataIndex: 'ModuleCode',
      key: 'ModuleCode'
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      render: (text, record) => (
        <>
          <Button onClick={() => _editRecord(record)} >
            <Tooltip title="Edit">
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={'Are You Sure That You Want To Delete'}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteRecord(record.Id)}
            okText={'yes'}
            cancelText={'No'}
          >
            <Button >
              <span>
                <Tooltip title={'Delete'}>
                  <DeleteOutlined />
                </Tooltip>
              </span>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 143 }}>
      <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
        <Button type="primary" onClick={OpenDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add DynamicHierarchy')}
        </Button>
      </div>
      <StyledTable size="small"
        columns={columns}
        dataSource={list}
        pagination={
          list.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update DynamicHierarchy')
            : translation(translationCache, 'Add DynamicHierarchy')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleDynamic}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item label={translation(translationCache, 'Name')} name="Name">
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'ModuleCode')}
            name="ModuleCode"
            rules={[{ required: true, message: translation(translationCache, 'Please select ModuleCode') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter ModuleCode')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Level')}
            name="Level"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Level !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Level')} />
          </Form.Item>
          <Form.Item label={translation(translationCache, 'LevelType')} name="LevelType">
            <Input placeholder={translation(translationCache, 'Please enter LevelType')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Type')}
            name="Type"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Type !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Type')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Actions')}
            name="Actions"
            rules={[{ required: true, message: translation(translationCache, 'Please select Actions') }]}
          >
            <Input.TextArea
              style={{ width: '70%' }}
              value={formObject && formObject.Actions ? JSON.stringify(formObject.Actions, null, 2) : null} // Format JSON for readability
              placeholder={translation(translationCache, 'Please enter Actions')}
              onChange={(e) => handleChange(e, 'Actions')}
            />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(DynamicHierarchy);